import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Snackbar,
  Alert,
  Input,
  InputAdornment,
  IconButton,
  Box,
  Dialog, DialogTitle, DialogContent, DialogActions
} from "@mui/material";
import axios from "axios";
import {
  CognitoUser,
  AuthenticationDetails,
  CognitoUserPool,
} from "amazon-cognito-identity-js";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import "./admin.css";

import AWS from "aws-sdk"; // ✅ FIXED
import { useNavigate } from "react-router-dom"; // ✅ FIXED
import "./admin.css";
import { axiosInstance } from "../../services/axiosInstance";
import { endpoints } from "../../services/endpoint";
import CCBMainLogo from "../../assets/CCBMainLogo.webp";
import mainImage from "../../assets/Login Page.png";
import { HmacSHA256, enc } from "crypto-js";
const AdminPage = () => {
  const [username, setUsername] = useState("");
  useEffect(() => {
    localStorage.setItem("username", username);
  }, [username]);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(""); // ✅ FIXED
  const [errorMessage, setErrorMessage] = useState("");     // ✅ FIXED
  const [showSnackbar, setShowSnackbar] = useState(false);  // ✅ FIXED
  const [showPassword, setShowPassword] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);

  const handleToggleVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handlePaste = (e) => {
    e.preventDefault(); // disables paste
  };
  const navigate = useNavigate(); // ✅ FIXED
  const clientId = "2uvhq5ggbnhforrcf4c23hgnrb";
  const clientSecret = "1hli39mec4nr8at19ahf9p95tuuotaju9srk8b96riked748nog4";
  const getUserPool = () => {
    return new CognitoUserPool({
      UserPoolId: "us-east-1_qelAiyyZO",
      ClientId: clientId,

    });
  };
  const generateSecretHash = (username) => {
    return HmacSHA256(username + clientId, clientSecret).toString(enc.Base64);
  };

  const configureAWS = () => {
    AWS.config.update({
      region: "us-east-1",
    });
  };

  const attemptAuthentication = async (username, password, instanceName) => {
    const cognitoIdentityServiceProvider = new AWS.CognitoIdentityServiceProvider({
      region: 'us-east-1'
    });

    const params = {
      AuthFlow: 'USER_PASSWORD_AUTH', // ✅ Change to USER_PASSWORD_AUTH
      ClientId: clientId,
      AuthParameters: {
        USERNAME: instanceName,
        PASSWORD: password,
        Name: username,
        SECRET_HASH: generateSecretHash(instanceName)
      }
    };

    try {
      const result = await cognitoIdentityServiceProvider.initiateAuth(params).promise();
      return result;
    } catch (error) {
      throw error;
    }
  };

  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
  const email = localStorage.getItem("Email");
  const instanceId = localStorage.getItem("InstanceId");
  const region = localStorage.getItem("Region");
  const EncryptedInstanceId = localStorage.getItem("EncryptedId");
  // Log the values
  console.log("CustomerAWSAccountId:", customerAWSAccountId);
  console.log("Email:", email);
  console.log("InstanceId:", instanceId);
  console.log("EncryptedId", EncryptedInstanceId)
  console.log("Region:", region);
  const [open, setOpen] = useState(false);

  const handleMainForgotPasswordClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // const createS3BucketForPrompts = async (payload) => {
  //   try {
  //     const response = await axiosInstance.post(
  //       endpoints.s3Prompts.createBucket,
  //       payload
  //     );
  //     return response.data;
  //   } catch (error) {
  //     console.error("Error creating S3 bucket for prompts:", error);
  //     throw error;
  //   }
  // };

  const handleLogin = async () => {
    if (!username || !password) {
      setErrorMessage("Please fill in all fields.");
      setShowSnackbar(true);
      return;
    }

    try {
      setLoading(true);

      const preAuthResult = await axios.post(
        "https://grj87qmm19.execute-api.us-east-1.amazonaws.com/Test/ListAwsAccounts",
        {
          UserName: username,
          Password: password,
        }
      );

      const responseData = preAuthResult.data;

      // Check for unauthorized or failed status
      if (responseData.statusCode === 401 || responseData.status === "Failed" || responseData.status === "failed") {
        setErrorMessage(responseData.message || "Invalid credentials");
        setShowSnackbar(true);
        setLoading(false);
        return;
      }

      console.log("API success:", responseData);

      setSuccessMessage("Login successful! Redirecting...");
      setShowSnackbar(true);
      setLoginSuccess(true);

      // Handle cases where body is undefined or stringified
      let body = responseData.body;
      if (typeof body === "string") {
        try {
          body = JSON.parse(body);
        } catch (e) {
          console.error("Failed to parse body:", e);
        }
      }
      if (!body) body = responseData;

      // ✅ Store login info
      localStorage.setItem("CustomerAWSAccountId", body.CustomerAWSAccountId || "");
      localStorage.setItem("Email", body.Email || "");
      localStorage.setItem("InstanceId", body.InstanceId || "");
      localStorage.setItem("Region", body.Region || "");
      localStorage.setItem("EncryptedId", body.EncryptedInstanceId || "");
      localStorage.setItem("LoginResponse", JSON.stringify(responseData));
      localStorage.setItem("username", username); // ✅ for navbar

      // ✅ Redirect to AWS Accounts Page
      setTimeout(() => {
        navigate("/aws-AccountsList-page");
      }, 100);

    } catch (error) {
      console.error(
        "Login failed:",
        error.response?.data?.message || error.message || error
      );

      setErrorMessage(
        `Login failed: ${error.response?.data?.message || error.message || "An error occurred."
        }`
      );
      setShowSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Enter' && !loading) {
        handleLogin();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [loading, handleLogin]);


  return (
    <Card className="admin-card">

      <CardContent>
        <div className="main-admin-logo-container">
          <img src={mainImage} alt="Logo" className="admin-main-logo" />
        </div>
        {/* <Typography className="accountnumbertext-styling">
          Instance Name
        </Typography>
        <Input
          className="input-placeholder"
          placeholder="Enter instance Name"
          label="Instance Name"
          value={instanceName}
          onChange={(e) => setInstanceName(e.target.value)}
        /> */}
        <Typography className="usernametext-styling">
          Username
        </Typography>
        <Input
          className="input-placeholder"
          placeholder="Enter your name"
          label="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <Typography className="usernametext-styling">
          Password
        </Typography>
        <Input
          className="input-placeholder"
          placeholder="Enter your Password"
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onPaste={handlePaste} // prevents pasting
          endAdornment={
            <InputAdornment position="end" className="password-adornment">
              <IconButton
                onClick={handleToggleVisibility}
                className="toggle-visibility-icon"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>

          }
        />

        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={handleLogin}
          disabled={loading || loginSuccess}
          className="loginbtn"
          style={{
            backgroundColor: loading || loginSuccess ? "#cccccc" : "#0d4ccd",
          }}
        >
          {loading ? "Login" : "Login"}
        </Button>

        <Snackbar
          open={showSnackbar}
          autoHideDuration={4000}
          onClose={() => setShowSnackbar(false)}
        >
          <Alert
            onClose={() => setShowSnackbar(false)}
            severity={successMessage ? "success" : "error"}
            sx={{ width: "100%" }}
          >
            {successMessage || errorMessage}
          </Alert>
        </Snackbar>

      </CardContent>

      <Typography variant="text" sx={{ fontSize: "14px" }}>
        New user?
        <Button
          variant="text"
          sx={{ fontSize: "14px", textTransform: "none" }}
          onClick={() => navigate("/signup-page")}
        >
          Sign up
        </Button>
      </Typography>
      <Typography>
        <Button
          onClick={handleMainForgotPasswordClick}
          className="imp-text-forgot"
          variant="text" // Use "text" variant for link-like styling
          color="primary"
        >
          Forgot Password?
        </Button>
      </Typography>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Forgot Password</DialogTitle>
        <DialogContent>
          Please contact the administrator.
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default AdminPage;
